import { configureStore } from "@reduxjs/toolkit";

import rootReducer from "shared/redux/appReducers";

const excludeSerializableCheck = {
  serializableCheck: false,
};

const store = configureStore({
  reducer: rootReducer,
  devTools: false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(excludeSerializableCheck),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
